import { UserGroupIcon, TagIcon, ChartBarIcon } from '@heroicons/react/24/outline';
import { OVERVIEW_CARD_EMPTY_COPY } from './testGroupDetailOverview.constants';

export const OVERVIEW_EMPTY_CARDS = [
  {
    id: 'testCaseSummary',
    title: 'Test Cases Summary',
    description: OVERVIEW_CARD_EMPTY_COPY.testCaseSummary,
    icon: UserGroupIcon,
    color: 'primary',
    visualType: 'summary',
  },
  {
    id: 'tagBreakdown',
    title: 'Test Cases by Module',
    description: OVERVIEW_CARD_EMPTY_COPY.tagBreakdown,
    icon: TagIcon,
    color: 'secondary',
    visualType: 'pie',
  },
  {
    id: 'testCaseGrowth',
    title: 'Test Case Growth',
    description: OVERVIEW_CARD_EMPTY_COPY.testCaseGrowth,
    icon: ChartBarIcon,
    color: 'secondary',
    visualType: 'line',
  },
];
